import { IGenericDTO, IInlineEditingContextDTO } from "coreframetypings/dto";
import ComponentManager from '@/Management/ComponentManager';
import EditLinkViewModel from '@/Components/Links/EditLink/EditLinkViewModel';
import type ExtendedInlineEditingGridViewModel from '@/Components/ExtendedInlineEditingGrid/ExtendedInlineEditingGridViewModel';
import Utilities from '@/Utility/Utilities';

export default class ExtIEGEditLinkViewModel extends EditLinkViewModel {

    /**
     * The current inline editing context
     */
    protected inlineEditingContext: KnockoutObservable<IInlineEditingContextDTO>;

    /**
     * The primary sub association (if set)
     */
    protected primarySubAssociation: string;

    /**
     * Edit the sub association instead original association
     */
    protected editSubAssociation: string;

    public constructor(params: any) {
        super(params);

        this.inlineEditingContext = this.observableOrDefault(params.inlineEditingContext, null);
        this.primarySubAssociation = this.paramOrDefault(params.primarySubAssociation, '');
        this.editSubAssociation = this.paramOrDefault(params.editSubAssociation, false);
    }

    /**
     * @override
     */
    public onClick(openInNewWindow: boolean, event: JQuery.Event): void {
        if (this.editSubAssociation) {
            const alv = this.inlineEditingContext()?.primarySubAssociationListView;
            if (Utilities.isNullOrUndefined(alv))
                return;

            let grid = this.dataSource as ExtendedInlineEditingGridViewModel;
            let selected = grid.selected();
            let editContext = grid.getEditContextForRow(selected[0]);

            this.context.createContext(this.context, alv, this.getPdoId(selected), null, this.getPrincipalFilterMode(alv), editContext.genericObject);
        }
        else {
            super.onClick(openInNewWindow, event);
        }
    }

    /**
     * @override
     */
    protected getPdoId(row: IGenericDTO[]): string {
        if (this.editSubAssociation) {
            let pdoId = row[0].values[this.primarySubAssociation + '.PDO_ID'];

            return ko.isObservable(pdoId) ? pdoId() : pdoId;
        }

        return row[0].pdoId;
    }
}

ComponentManager.setViewModel('ExtIEGEditLink', ExtIEGEditLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');